/* eslint-disable */
/* tslint:disable */

import { ObjectStatusResponse, OrganizationObjectThreatResponse, StepStatusResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

class Statuses<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Статусы
	 * @summary Статусы шагов категорирования
	 * @request GET:/statuses/steps
	 * @secure
	 */
	stepsList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			org_id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<StepStatusResponse, void>({
			path: `/statuses/steps`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Статусы
	 * @summary Получение статуса утверждения документа
	 * @request GET:/statuses/objects
	 * @secure
	 */
	objectsList = (
		query: {
			/**
			 * id организации
			 * @format int32
			 */
			id: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ObjectStatusResponse, void>({
			path: `/statuses/objects`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Статусы
	 * @summary Сброс утверждения документа
	 * @request POST:/statuses/object/{id}/threats/status/reset
	 * @secure
	 */
	objectThreatsStatusResetCreate = (id: number, params: RequestParams = {}) =>
		this.request<OrganizationObjectThreatResponse, void>({
			path: `/statuses/object/${id}/threats/status/reset`,
			method: "POST",
			secure: true,
			format: "json",
			...params,
		});
}
export const statusesAPI = new Statuses();
